@import './RuleVars.less';

@gap: .5em;
@disableColor: #d9d9d9;

.xm-rules-list {
  display: flex;
  gap: @gap;
  flex-direction: column;

  .xm-rule {
    display: flex;
    gap: 1em;
  }

  .ant-collapse-item,
  .ant-collapse-content-active,
  .ant-collapse-content-hidden {
    border: none;
  }

  .ant-collapse-content-box {
    padding: 1em 0 1em 2.2em !important;
  }

  .xm-rule-controllers.main button {
    margin-right: @gap;
  }

  .ant-collapse {
    background-color: transparent;
    border: none;

    .ant-collapse-item {
      background-color: inherit;
      border-bottom: 1px solid @disableColor;

      &:last-child {
        border-bottom: none;
      }

      .ant-collapse-header {
        // left inset same as body so the chevron lines up with rule sections
        padding: .25em .25em .25em @rule-body-padding-x;

        // same preview/delete columns as rule sections - offset by body padding + section border
        .ant-collapse-extra>div {
          display: flex;
          margin-right: calc(@rule-body-padding-x + 1px);

          .xm-btn-controller {
            padding: 0;
            margin: 0;
            width: @rule-preview-width;
          }

          .xm-btn-controller:last-child {
            width: @rule-delete-width;
          }
        }
      }
    }

    .ant-collapse-item-active {
      .ant-collapse-header {
        border-bottom: none;
      }

      .ant-collapse-panel-active {
        background-color: inherit;
      }
    }

    .ant-collapse-body {
      padding-top: 1em;
      padding-bottom: 1em;
      padding-inline: @rule-body-padding-x;
    }

    .ant-collapse-item:last-child .ant-collapse-body {
      padding-bottom: 0;
    }

    .ant-collapse-content {
      background-color: inherit;

      &-box {
        padding: 1em;
      }
    }
  }
}